var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsstPopupBgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 685,
    height: 875,
    viewBox: "0 0 685 875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.622 156.834C130.455 114.667 529.622 -72.6602 511.622 90.8369C497.97 214.839 152.622 223.5 111.122 350C48.2922 541.517 543.622 625 655.122 394.5C706.122 265 332.722 244.1 87.1225 654.5C-158.478 1064.9 388.622 712 608.122 630",
    stroke: "#ABBAFF",
    strokeOpacity: 0.15,
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsstPopupBgVector);
export default __webpack_public_path__ + "static/media/asst-popup-bg-vector.a01dc8da77b752c3cff22ebc439004ab.svg";
export { ForwardRef as ReactComponent };